import { createAction } from 'redux-actions';
import {
    SAVE_CURRENT_PROFILE,
    LOAD_CURRENT_PROFILE,
    CancelModificationAction,
    CANCEL_MODIFICATION,
    LOAD_CURRENT_NOTIFICATIONS,
    SAVE_CURRENT_NOTIFICATIONS,
} from './Types';
import { ProfileManagementService } from '../../Services/ProfileManagement/Service';
import { IGetCurrentUserDetailsQueryResponseDto } from '../../Services/ClientProxy/clientProxy';
import { RecipientPreferenceRequestDto } from '../../Services/ClientProxy/NotificationManagementClient';

const profileManagementService = new ProfileManagementService();
// TypeScript infers that this function is returning SendMessageAction

export const loadCurrentProfile = createAction(
    LOAD_CURRENT_PROFILE,
    async () => {
        try {
        const result = await profileManagementService.getProfile();
        return result;
        }catch{
            return {};
        }
    }
);
export const saveCurrentProfile = createAction(
    SAVE_CURRENT_PROFILE,
    async (profile: IGetCurrentUserDetailsQueryResponseDto) => {
        try {
            await profileManagementService.updateCurrentProfile(profile);
        } catch (serviceError) {
            return { lastError: serviceError, profile };
        }
        return { lastError: null, profile };
    }
);

export const loadCurrentNotifications = createAction(
    LOAD_CURRENT_NOTIFICATIONS,
    async () => {
        try {
        const result = await profileManagementService.getCurrentNotifications();
        return result;
    }catch{
        return {};
    }
    }
);
export const saveCurrentNotifications = createAction(
    SAVE_CURRENT_NOTIFICATIONS,
    async (Notification: RecipientPreferenceRequestDto) => {
        try {
            await profileManagementService.updateCurrentNotifications(
                Notification
            );
        } catch (serviceError) {
            return { lastError: serviceError, Notification };
        }
        return { lastError: null, Notification };
    }
);

export function cancelModification(): CancelModificationAction {
    return {
        type: CANCEL_MODIFICATION,
    };
}
